import Vue from 'vue'
import axios from 'axios'
import constants from '@/app-configs/constants'

const axiosInsDuplicate = axios.create({
// You can add your headers here
// ================================
// baseURL: 'https://some-domain.com/api/',
// timeout: 1000,
// headers: {'X-Custom-Header': 'foobar'}
// baseURL: 'https://api.notifications.debtia.dk/api/',
  baseURL: constants.communicationBaseUrl,
// baseURL: 'http://127.0.0.1:8000/api/v1/',
})
Vue.prototype.$http = axiosInsDuplicate

export default axiosInsDuplicate
